import React, { createContext, useReducer } from 'react'

import { reducer, propsToState } from './reducer'
import { createActions } from './actions'

export const AstuteContext = createContext({})

export const AstuteProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, propsToState(props))
  const actions = createActions(dispatch, state)

  return (
    <section>
      <AstuteContext.Provider value={{ state, actions }}>
        {props.children}
      </AstuteContext.Provider>
    </section>
  )
}
